<template>
  <div class="hello">
    <div>绑定后，微信可以接收设备报警推送</div>
    <div
      style="max-height: 400px;width: 100%;overflow: scroll;margin-top: 10px;"
    >
      <div
        class="input-form"
        style="
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
      "
        :style="styleObject"
      >
        <div
          v-for="(item, index) in getUserPlatformlist"
          :key="index"
          class="labelNoSelect"
          :class="{ labelSelect: isActive == index }"
          @click="showQuarter(index)"
        >
          <div>{{ item.sitename }}</div>
        </div>
      </div>
    </div>
    <button class="btn-grays" @click="unbindWeChat">
      已经绑定，点击可进行解绑
    </button>
  </div>
</template>
<script>
const TIME_COUNT = 60;
import { Toast, MessageBox } from "mint-ui";
export default {
  name: "bindPhone",
  data() {
    return {
      styleObject: {
        marginTop: "0px"
      },
      isActive: 10,
      count: "获取验证码",
      timer: null,
      isShow: false,
      datacode: 0, //200：账号可以绑定，202：账号已经被其他微信绑定
      request: {
        phone: "",
        code: "",
        platformId: ""
      },
      bindRequest: {
        openId: "",
        phone: ""
      },
      user: {},
      getUserPlatformlist: [
        { sitename: "名字" },
        { sitename: "名字" },
        { sitename: "名字" },
        { sitename: "名字" }
        // { sitename: "名字" },
        // { sitename: "名字" },
        // { sitename: "名字" },
        // { sitename: "名字" },
        // { sitename: "名字" },
        // { sitename: "名字" },
        // { sitename: "名字" },
        // { sitename: "名字" },
        // { sitename: "名字" },
        // { sitename: "名字" },
        // { sitename: "名字" },
        // { sitename: "名字" }
      ]
    };
  },
  mounted() {
    this.bindRequest.openId = this.$route.query.openId;
    this.bindRequest.phone = this.$route.query.phone;
    console.log(window.innerHeight);
    // 先获取平台信息
    this.getUserPlatform();
  },
  methods: {
    getCodebutton() {
      console.log(123);
      var re = new RegExp(/^1\d{10}$/); //当使用构造函数创造正则对象时，需要常规的字符转义规则（在前面加反斜杠 \）
      if (!this.request.phone.match(re)) {
        Toast("请输入11位的手机号码");
        return false;
      }
      this.getUserPlatform();
      var _t = this;
      _t.common.doAction(
        _t.common.smsCode,
        {
          mobile: _t.request.phone,
          platformId: 1,
          userWay: "wxbind"
        },
        function(res) {
          if (res.code != 200) {
            MessageBox.alert(res.msg, "ERROR");
          }
          if (!_t.timer) {
            _t.count = TIME_COUNT;
            _t.show = false;
            _t.timer = setInterval(() => {
              if (_t.count > 0 && _t.count <= TIME_COUNT) {
                _t.count--;
              } else {
                _t.count = "获取验证码";
                clearInterval(_t.timer);
                _t.timer = null;
              }
            }, 1000);
          }
        },
        "weixin"
      );
    },
    // 获取绑定手机号平台信息
    getUserPlatform() {
      var _t = this;
      _t.common.doActionGet(
        _t.common.getUserPlatform,
        {
          phone: _t.bindRequest.phone
        },
        function(res) {
          if ((res.code = 200)) {
            console.log(res.data, 148);
            _t.getUserPlatformlist = res.data;
            if (res.data.length == 1) {
              _t.showQuarter(0);
            }
            // if (_t.getUserPlatformlist.length < 5) {
            //   _t.styleObject.marginTop = _t.getUserPlatformlist.length * 30 + "px";
            // }
            // _t.getUserPlatformlist.length * 24

            console.log(
              window.innerHeight / 2 - _t.getUserPlatformlist.length * 45
            );
            console.log(_t.getUserPlatformlist.length * 45);
            // if(_t.getUserPlatformlist.length * 45 < window.innerHeight){
            //   _t.styleObject.marginTop  = window.innerHeight/2 - - _t.getUserPlatformlist.length * 45+ "px"
            // }
          }
        },
        "dd"
      );
    },
    bindWeChat() {
      // if (this.request.phone == "") {
      //   Toast("请输入手机号");
      //   return;
      // }
      // if (this.request.code == "") {
      //   Toast("请输入验证码");
      //   return;
      // }
      this.getUserInfo();
      //调用接口查询要绑定的用户信息
    },
    //调用接口查询要绑定的用户信息
    getUserInfo() {
      // var _t = this;
      console.log(this.bindRequest.platformId);

      let system = navigator.userAgent;
      let isAndroid =
        system.indexOf("Android") > -1 || system.indexOf("Adr") > -1; // android终端
      let isiOS = !!system.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      console.log(isiOS);
      console.log(isAndroid);
      if (isAndroid) {
        //android终端
        this.resultlist = "安卓";
        // window.open('https://www.baidu.com/')
        window.open(
          "https://wxapi.lny119.com/wechat/md/wxLogin" +
            "?phone=" +
            this.bindRequest.phone +
            "&platformId=" +
            this.bindRequest.platformId,
          "_blank"
        );
      } else if (isiOS) {
        //ios终端
        console.log("我是ios");
        this.resultlist = "我是ios";
        // window.location.href = 'https://www.baidu.com/'
        window.location.href =
          "https://wxapi.lny119.com/wechat/md/wxLogin" +
          "?phone=" +
          this.bindRequest.phone +
          "&platformId=" +
          this.bindRequest.platformId;
      }

      // this.common.doActionGet(
      //   _t.common.wxLogin,
      //   _t.bindRequest,
      //   function (res) {
      //     if (res.code == 200 || res.code == 202) {
      //       // _t.datacode = res.code;
      //       // _t.isShow = true;
      //       // if (res.code == 202) {
      //       //   _t.user.username = res.data.nickname;
      //       //   _t.user.userlogo = res.data.headImgUrl;
      //       // } else {
      //       //   _t.user.username = res.data.username;
      //       //   _t.user.userlogo = res.data.userlogo;
      //       // }
      //     } else {
      //       MessageBox.alert(res.msg, "ERROR");
      //     }
      //   },
      //   "weixin"
      // );
    },
    sureBind() {
      var _t = this;
      this.bindRequest.phone = this.request.phone;
      this.bindRequest.platformId = this.request.platformId;
      this.common.doActionGet(
        this.common.mdbindLny,
        this.bindRequest,
        function(res) {
          if (res.code == 200) {
            //绑定成功,跳转到详情页bindDetail,否则提示失败原因
            var query = {
              openId: _t.bindRequest.openId
            };
            _t.$router.push({
              path: "/bindDetailnew",
              query: query
            });
          } else {
            MessageBox.alert("ERROR", res.msg);
          }
        },
        "weixin"
      );
    },
    showQuarter(index) {
      this.isActive = index;
      console.log(this.getUserPlatformlist[index]);
      this.bindRequest.platformId = this.getUserPlatformlist[index].siteid;
      // this.requestData.type=index;
      // if (index == 2) {
      //   this.requestData.type=4;
      // }
      this.getUserInfo();
    },
    //解绑
    unbindWeChat() {
      var _t = this;
      console.log(_t.bindRequest, 276);
      MessageBox.confirm("解绑后将不再接受单位设备的报警信息！")
        .then(action => {
          _t.common.doActionGet(
            _t.common.mdremoveBindLny,
            _t.bindRequest,
            function(res) {
              if (res.code == 200) {
                //绑定成功,跳转到详情页bindDetail,否则提示失败原因
                var query = {
                  openId: _t.bindRequest.openId,
                  phone: _t.bindRequest.phone
                };
                _t.$router.push({
                  path: "/bindPhoneno",
                  query: query
                });
              } else {
                MessageBox.alert(res.msg, "ERROR");
              }
            },
            "weixin"
          );
        })
        .catch(_ => {});
    }
  }
};
</script>
<style scoped>
@import "../../../static/wechat/wechat.css";
.hello {
  /* height: 100%; */
  padding: 0px 20px;
}
.title1 {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  margin-top: 60px;
}
.title2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  margin-top: 10px;
}
.input-form {
  /* position: absolute;
    bottom: 20px;
    top: 152px;
    left: 0; */
  width: 100%;
  /* margin-top: 70px; */
  margin-bottom: 36px;
  height: 100%;
  /* height: 100%; */
  /* overflow-y: auto;
}
.input-container {
  height: 24px;
  padding-top: 20px;
  padding-bottom: 10px;
  /* border-bottom: 1px solid #e4e4e4; */
  display: flex;
  align-items: center;
}
.input-container img {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}
.input-container input {
  border: none;
  flex-grow: 1;
  height: 24px;
  line-height: 24px;
  min-width: 100px;
  font-size: 14px;
}
.btn-code {
  /* width: 100px; */
  height: 26px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #007aff;
  color: #007aff;
  font-size: 12px;
  flex: 0 0 80px;
  white-space: nowrap;
}
.labelSelect {
  /* border: 2px solid #1e376c; */
  /* color: #007aff; */
}
.labelNoSelect {
  display: flex;
  justify-content: center;
  padding: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  border: 1px solid #eee;
  padding: 10px;
  margin-top: 10px;
  width: 70%;
}
.bottom-button {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
.btn-grays {
  width: 70%;
  height: 40px;
  margin-top: 50px;
  background: #7caf5f !important;
  border-radius: 4px;
  border: 1px solid #7caf5f !important;
  font-size: 14px;
  color: #fff !important;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  box-shadow: 0 4px 8px rgba(129, 151, 111, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/wechat/platformnew.vue